export default function (Component) {
Component.options.__tip = "<p>Using fixed columns is still experimental.</p>\n"
}